import { MAGIC_ARTIFACT_PREFIX, MAGIC_SOURCE_PREFIX } from '../super'
import { normalizeCitations } from './normalizeCitations'

const MAGIC_SOURCE_PATTERN = new RegExp(
  `\\{${MAGIC_SOURCE_PREFIX}(\\d+)\\}`,
  'g'
)

const MAGIC_SOURCE_V2_LEGACY_PATTERN = new RegExp(
  `.${MAGIC_SOURCE_PREFIX}(\\d+)[\\},]`,
  'g'
)

// New v2 pattern for :ref[text]{ids=5L1T3-x,5L1T3-y} format
const MAGIC_SOURCE_V2_PATTERN = new RegExp(
  `:ref\\[[^\\]]*\\]\\{ids=((?:${MAGIC_SOURCE_PREFIX}\\d+(?:,${MAGIC_SOURCE_PREFIX}\\d+)*)?)\\}`,
  'g'
)

const MAGIC_ID_PATTERN = new RegExp(
  `\\{(${MAGIC_ARTIFACT_PREFIX}|${MAGIC_SOURCE_PREFIX})(\\d+)\\}`,
  'g'
)

// Pattern for new v2 format in remapping
const MAGIC_ID_V2_PATTERN = new RegExp(
  `:ref(\\[[^\\]]*\\])\\{ids=((?:(?:${MAGIC_ARTIFACT_PREFIX}|${MAGIC_SOURCE_PREFIX})\\d+(?:,(?:${MAGIC_ARTIFACT_PREFIX}|${MAGIC_SOURCE_PREFIX})\\d+)*))\\}`,
  'g'
)

export function findAllCitations({
  text: rawText,
  v2,
  useLegacyV2,
}: {
  text: string
  v2?: boolean
  useLegacyV2?: boolean
}) {
  const text = v2 && !useLegacyV2 ? normalizeCitations(rawText) : rawText

  let pattern: RegExp

  if (v2) {
    pattern = useLegacyV2
      ? MAGIC_SOURCE_V2_LEGACY_PATTERN
      : MAGIC_SOURCE_V2_PATTERN
  } else {
    pattern = MAGIC_SOURCE_PATTERN
  }

  const relativeIdSet = new Set<string>()

  if (v2 && !useLegacyV2) {
    // new v2 format: :ref[text]{ids=5L1T3-1,5L1T3-2}
    for (const match of text.matchAll(pattern)) {
      const idsString = match[1]
      if (idsString) {
        const ids = idsString.split(',').map((id) => id.trim())
        ids.forEach((id) => {
          if (id.startsWith(MAGIC_SOURCE_PREFIX)) {
            relativeIdSet.add(id)
          }
        })
      }
    }
  } else {
    for (const match of text.matchAll(pattern)) {
      const relativeId = match.at(0)?.slice(1, -1)
      if (relativeId) {
        relativeIdSet.add(relativeId)
      }
    }
  }

  return [...relativeIdSet.keys()]
}

export function remapAllCitations({
  text: rawText,
  remappings,
  v2,
  useLegacyV2,
}: {
  text: string
  remappings: Record<string, string>
  v2?: boolean
  useLegacyV2?: boolean
}) {
  const text = v2 && !useLegacyV2 ? normalizeCitations(rawText) : rawText

  if (v2 && !useLegacyV2) {
    // new v2 format: :ref[text]{ids=5L1T3-1,5L1T3-2}
    return text.replace(MAGIC_ID_V2_PATTERN, (match, textPart, idsString) => {
      const ids = idsString.split(',').map((id: string) => id.trim())
      const remappedIds = ids.map((id: string) => {
        return remappings[id] || id
      })
      return `:ref${textPart}{ids=${remappedIds.join(',')}}`
    })
  }

  return text.replace(MAGIC_ID_PATTERN, (match) => {
    const relativeId = match.slice(1, -1)
    return remappings[relativeId] ? `{${remappings[relativeId]}}` : match
  })
}
